import { sdk } from './axios'

export const etlService = {
  getConfig() {
    return sdk.request({
      url: '/etl/config',
      method: 'post'
    })
  },
  
  updateConfig(data) {
    return sdk.request({
      url: '/etl/config/update',
      method: 'post',
      data
    })
  },
  
  runJob() {
    return sdk.request({
      url: '/etl/run',
      method: 'post'
    })
  },
  
  resumeJob() {
    return sdk.request({
      url: '/etl/resume',
      method: 'post'
    })
  },
  
  pauseJob() {
    return sdk.request({
      url: '/etl/pause',
      method: 'post'
    })
  },
  
  modifyInterval(data) {
    return sdk.request({
      url: '/etl/interval',
      method: 'post',
      data
    })
  },
  
  getStatus() {
    return sdk.request({
      url: '/etl/status',
      method: 'post'
    })
  }
}
